module.exports = __webpack_public_path__ + "static/media/plan.64c9cefb.png";